import { Button, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';

import QuestionCircleOutlined from '@/comp/common/icons/QuestionCircleOutlined';
import { ImageUploadButtons } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/components';
import { useImageCompression } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/hooks';
import { useStores } from '@/hooks/use-stores';
import { ImageTags } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/components/MobileUploadWizzard/components/common';
import { EPButton } from '@/components';
import { ModalContent } from '../ImageList.styles';
import { MAX_IMAGE_UPLOAD_COUNT } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/ImageUpload.consts';

const UploadPicturesDesktop = observer(() => {
  const { t } = useTranslation();
  const { imageUploadStore, devicesStore } = useStores();
  const hasReachedMaxImages = devicesStore.deviceImages?.length >= MAX_IMAGE_UPLOAD_COUNT;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const params = useImageCompression({
    onComplete: imageUploadStore.goToNextStep,
  });

  const toggleModalOpen = () => setIsModalOpen(prev => !prev);

  return (
    <div className="image-list-header">
      <ImageUploadButtons buttonText="uploadPictures" isDisabled={hasReachedMaxImages} {...params} />
      <EPButton
        type="text"
        className="open-image-tags-drawer-btn"
        icon={<QuestionCircleOutlined />}
        onClick={toggleModalOpen}
      >
        {t('uploadImageMobilePreviewHelperText')}
      </EPButton>
      <Modal open={isModalOpen} onCancel={toggleModalOpen} footer={null}>
        <ModalContent>
          <p className="image-tags-drawer-title">{t('uploadImageTagsDrawerTitle')}</p>
          <ImageTags className="image-tags-list" />
          <Button className="image-tags-drawer-close-btn" size="large" type="primary" onClick={toggleModalOpen}>
            {t('Close')}
          </Button>
        </ModalContent>
      </Modal>
    </div>
  );
});

export default UploadPicturesDesktop;
